import { RevenueModel } from '@avantstay/arriere-clients/dist/arriereBackoffice'

export const revenueModelLabel: Record<string, string> = {
  [RevenueModel.distribution]: 'Distribution',
  [RevenueModel.hybrid]: 'Hybrid',
  [RevenueModel.leased]: 'Leased',
  [RevenueModel.managed]: 'Managed',
  [RevenueModel.undefined]: '-',
}

export const revenueModelShortLabel: Record<string, string> = {
  [RevenueModel.hybrid]: 'Hyb',
  [RevenueModel.leased]: 'L',
  [RevenueModel.managed]: 'Mng',
  [RevenueModel.undefined]: '-',
}
